'use strict'

const cartErrorEvent = {
    emitEvent (data) {
        const event = new CustomEvent('cartError', {
            detail: data
        });

        window.dispatchEvent(event);
    }
}

export default cartErrorEvent;
